import React, { useState } from 'react'
import { BUTTON_VARIANT, Button } from 'components/Button'
import { Box, Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { COLOR_INTENT, FONT_SIZE, SPACE } from 'Theme'

interface ButtonCheckboxGroupProps {
  items: { value: string; label: string }[]
  name: string
  label: string
  onChange?: (value: string[]) => void
}

const ButtonCheckboxGroup: React.FC<ButtonCheckboxGroupProps> = ({
  items,
  name,
  label,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState<string[]>([items[0].value])

  const handleButtonClick = (value: string) => {
    const newSelectedValue = selectedValue.includes(value)
      ? selectedValue.filter((item) => item !== value)
      : [...selectedValue, value]

    if (!newSelectedValue.length) {
      return
    }

    if (onChange) {
      onChange(newSelectedValue)
    }
    setSelectedValue(newSelectedValue)
  }

  return (
    <Box mb={SPACE.PX_24}>
      <Flex pb={SPACE.PX_8}>
        <Text>{label}</Text>
      </Flex>{' '}
      <Flex pb={SPACE.PX_8}>
        <Text color={COLOR_INTENT.GRAY_60} fontSize={FONT_SIZE.PX_12}>
          You choose multiple options (at least one)
        </Text>
      </Flex>
      <Flex
        flexDirection="row"
        flexWrap="wrap"
        style={{ columnGap: SPACE.PX_8 }}
      >
        {items.map((item) => (
          <input
            key={item.value}
            name={name}
            type="checkbox"
            id={item.value}
            value={item.value}
            checked={selectedValue.includes(item.value)}
            onChange={() => handleButtonClick(item.value)}
            style={{ display: 'none' }}
          />
        ))}
        {items.map((item) => (
          <Flex key={item.value} flexGrow="1" pb={SPACE.PX_8}>
            <Button
              variant={
                selectedValue.includes(item.value)
                  ? BUTTON_VARIANT.FILLED
                  : BUTTON_VARIANT.OUTLINE
              }
              type="button"
              onClick={() => handleButtonClick(item.value)}
            >
              {item.label}
            </Button>
          </Flex>
        ))}
      </Flex>
    </Box>
  )
}

export default ButtonCheckboxGroup
